import { Buffer } from "buffer";

// @solana/spl-token references Buffer at module-evaluation time. ES imports
// resolve depth-first, so this file must be imported BEFORE anything that
// pulls in spl-token (i.e. first import in main.tsx).
if (typeof window !== "undefined" && !(window as { Buffer?: unknown }).Buffer) {
  (window as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;
}
